import { PORTAL_COMERCIOS } from "../../Consulta/utilities/constants";

export const presentacionPresentarRequest = () => ({
  idComercio: 0,
  preCupon: 0,
  productoId: 0,
  idUsuario: 0,
  nombrePdf: "",
  totalOnLine: 0,
  preOrigen: PORTAL_COMERCIOS
});
